import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import React from "react";

const Alert = (props) => {
    return <MuiAlert elevation={6} variant="standard" {...props} />;
}

const SnackbarAlert = (props) => {
    const vertical = "top";
    const horizontal = "center";
    // Keep the last open toast through the exit animation. Callers clear the
    // message and switch severity to "error" as soon as they close it.
    const shown = React.useRef({ type: props.type, msg: props.msg });
    if (props.openAlert) {
        shown.current = { type: props.type, msg: props.msg };
    }

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        props.setOpenAlert({ alert: false });
    };

    return (
        <Snackbar
            open={props.openAlert}
            autoHideDuration={5000}
            onClose={handleCloseAlert}
            anchorOrigin={{ vertical, horizontal }}
        >
            <Alert onClose={handleCloseAlert} severity={shown.current.type}>
                {shown.current.msg}
            </Alert>
        </Snackbar>
    );
}

export default SnackbarAlert;